// Figma names these layers `bottom_panel_open` / `bottom_panel_close`, but the
// glyphs they contain are Material's left-panel pair: a vertical divider near
// the left edge with a horizontal arrow. They are registered under the
// semantic name so `<Icon>left_panel_open</Icon>` renders what it says and the
// `bottom_panel_*` names stay free for a genuine bottom-drawer icon.
import { createSvgIcon } from '@mui/material';

const IconLeftPanelOpen = createSvgIcon(
  <path
    d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2ZM5 5h3v14H5ZM10 5h9v14h-9ZM12.5 8l4 4-4 4Z"
    fillRule="evenodd"
  />,
  'left_panel_open',
);

export default IconLeftPanelOpen;
